import * as S from './styles';
import { useEffect, useRef, useState } from 'react';

interface ToolTipProps {
  text: string | React.ReactNode;
  time?: number;
  children: any;
  show?: boolean;
  bgcolor?: string;
  maxWidth?: string;
  callback?: () => void;
  direction?: 'top' | 'bottom';
  displayMode?: 'hover' | 'click' | 'default';
}

const { userAgent } = navigator;
const tabletRegex = /iPad|tablet|playbook|silk|Macintosh|Windows|Linux|X11/i;
const mobileRegex = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i;
const isMobile = mobileRegex.test(userAgent) && !tabletRegex.test(userAgent);

const ToolTip: React.FC<ToolTipProps> = ({
  text,
  show,
  time,
  bgcolor,
  callback,
  children,
  maxWidth,
  direction = 'top',
  displayMode: mode = 'hover',
}) => {
  const displayMode = mode === 'hover' && isMobile ? 'click' : mode;
  const [showTooltip, setShow] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (displayMode === 'hover') return;
    if (!showTooltip) return;

    timerRef.current = setTimeout(() => {
      setShow(false);
    }, time ?? 3000);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [showTooltip, displayMode, time]);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();

    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (!show) {
      setShow(!showTooltip);
    }
  };

  const handleCallback = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (showTooltip) return;
    if (callback) {
      callback();
    }
  };

  return (
    <>
      {displayMode === 'hover' ? (
        <S.Content onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
          {children}

          <S.Tolltip $maxWidth={maxWidth} $bgcolor={bgcolor} direction={direction} $show={showTooltip}>
            {text}
          </S.Tolltip>
        </S.Content>
      ) : displayMode === 'click' ? (
        <S.Content onClick={handleClick}>
          {children}

          <S.Tolltip $bgcolor={bgcolor} direction={direction} $show={showTooltip || !!show} $maxWidth={maxWidth}>
            {text}
          </S.Tolltip>
        </S.Content>
      ) : callback ? (
        <S.Content onClick={handleCallback}>
          {children}

          <S.Tolltip $bgcolor={bgcolor} direction={direction} $show={!!show} $maxWidth={maxWidth}>
            {text}
          </S.Tolltip>
        </S.Content>
      ) : (
        <S.Content>
          {children}

          <S.Tolltip $bgcolor={bgcolor} direction={direction} $show={!!show} $maxWidth={maxWidth}>
            {text}
          </S.Tolltip>
        </S.Content>
      )}
    </>
  );
};

export default ToolTip;
